import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeShortsMakerInputField } from '../../Redux/Actions/ToolActions.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import uuid from 'react-uuid';

import LoggedInUser from '../../LoggedInUser.js';
import Header from '../Header.js';
import FooterV2 from './FooterV2.js';
import './landing-v2.css';

// v2 landing page for Shorts Creator (standalone brand — no Ssemble references).
// Same underlying tool as the classic page, but wrapped in the TikTok-forward
// header/footer and passing variant="v2" so the tool renders the new marketing.
//
// SWITCHING: this page is selected in App.js via the USE_NEW_LANDING flag. The
// classic page remains untouched and reachable at /classic.

const id = uuid();

function LandingPage({ shortcodeSettings }) {
    const ToolState = useSelector((state) => state.ToolReducer);
    const dispatch = useDispatch();
    const { ShortsMakerField } = ToolState;

    const [requestId, setrequestId] = useState('');

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const requestIdParam = urlParams.get('requestId');
        if (requestIdParam !== undefined && requestIdParam !== null) {
            setrequestId(requestIdParam);
        }
    }, []);

    useEffect(() => {
        dispatch(
            changeShortsMakerInputField({
                shortcodeSettings1: shortcodeSettings,
            })
        );
    }, [ShortsMakerField.final_data]);

    useEffect(() => {
        dispatch(changeShortsMakerInputField({ id: id }));
    }, []);

    return (
        <div className="lp2-page">
            {/* Approved top menu — do NOT restyle. Uses the classic Header with the
                properly-visible logo that TikTok already approved. */}
            <Header />

            <LoggedInUser
                userId='Bt8FmpTSG7qA10Q2l-_nS'
                userEmail='taejun@vlogr.com'
                ytUrl=''
                requestId={requestId}
                onLoad=''
                onCreate=''
                variant='v2'
                ShortsMakerField={ShortsMakerField} />

            <FooterV2 />
        </div>
    );
}

export default LandingPage;
